import {
  BaseReminders,
  CreateReminder,
  Reminders,
  UpdateReminder,
  UpcomingFamilyReminder,
  ReminderTypeCounts,
} from "@/types/reminders";
import { BaseService, PaginatedResult } from "./base.service";
import { FilterSettingDto } from "@/types/filter";

class RemindersService extends BaseService {
  constructor() {
    super("reminders/");
  }

  async hasReminders(memberId: string): Promise<boolean> {
    return this.get<boolean>(`${memberId}/hasReminders`);
  }

  /**
   * Next few reminders across the whole family, for the dashboard widget.
   * `memberId` only satisfies the route shape — the backend uses the acting
   * member's family context, not this param.
   */
  async getUpcomingForFamily(
    memberId: string
  ): Promise<UpcomingFamilyReminder[]> {
    return this.get<UpcomingFamilyReminder[]>(`${memberId}/family-upcoming`);
  }

  async getReminderTypeCounts(memberId: string): Promise<ReminderTypeCounts> {
    return this.get(`${memberId}/type-counts`);
  }

  async getReminders(
    memberId: string,
    filters: FilterSettingDto
  ): Promise<PaginatedResult<BaseReminders>> {
    return this.post<PaginatedResult<BaseReminders>>(`${memberId}/getAll`, {
      filters: filters.filters,
      sort: filters.sort,
      pagination: filters.pagination,
    });
  }

  async getReminder(memberId: string, reminderId: string): Promise<Reminders> {
    return this.get<Reminders>(`${memberId}/${reminderId}`);
  }

  async createReminder(
    memberId: string,
    reminder: CreateReminder
  ): Promise<Reminders> {
    return this.post(`${memberId}`, reminder);
  }

  async updateReminder(
    memberId: string,
    reminderId: string,
    reminder: UpdateReminder
  ): Promise<Reminders> {
    return this.put(`${memberId}/${reminderId}`, reminder);
  }

  async deleteReminder(
    memberId: string,
    reminderId: string
  ): Promise<{ deleted: boolean }> {
    return this.delete(`${memberId}/${reminderId}`);
  }
}

export const remindersService = new RemindersService();
